import Notifications from './List'

export default [
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications,
    meta: {
      auth: true,
      permission: 'view',
    },
  },
]
